<template>
    <div class="budget-summary">

        <div class="text-right mb-8">
            <span class="d-block" v-if="honoraries">Honorarios: {{ honorariesInEuros }}</span>
            <span class="d-block" v-if="apostilles">Apostillas: {{ apostillesInEuros }}</span>
            <hr>
            <strong>{{ labelCost }}: {{ costInEuros }}</strong>
            <span class="d-block" v-if="cost">IVA (21%): {{ taxesInEuros }}</span>
            <span class="d-block" v-if="retention">- Retención IRPF (15%): -{{ retentionInEuros }}</span>
            <span class="d-block" v-if="service !== 'policies'">Total: {{ total }}</span>
            <hr>
            <span class="d-block" v-if="untaxedCosts">Suplidos: {{ untaxedCostsInEuros }}</span>
            <hr v-if="untaxedCosts">
            <h4><strong>IMPORTE A PAGAR: {{ totalCostInEuros }}</strong></h4>
        </div>

        <div class="d-flex justify-content-center">
            <slot></slot>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            labelCost: {
                default: 'Base Imponible',
                type: String
            },
            cost: { type: Number, required: true },
            honoraries: { type: Number, required: false },
            apostilles: { type: Number, required: false },
            retention: Boolean,
            untaxedCosts: { type: Number, required: false },
            service: { type: String, required: true },
            deliveryCost: { type: Number, required: false, default: 0 }
        },

        data: function () {
            return {
                json: {},
            }
        },

        computed: {
            costInEuros: function () {
                return this.cost.toFixed(2).replace(".", ",") + '€';
            },
            apostillesInEuros: function () {
                return this.apostilles.toFixed(2).replace(".", ",") + '€';
            },
            honorariesInEuros: function () {
                return this.honoraries.toFixed(2).replace(".", ",") + '€';
            },
            taxesInEuros: function () {
                return this.taxesAmount.toFixed(2).replace(".", ",") + '€';
            },
            retentionInEuros: function () {
                return this.retainedAmount.toFixed(2).replace(".", ",") + '€';
            },
            untaxedCostsInEuros: function () {
                return this.untaxedCosts.toFixed(2).replace(".", ",") + '€';
            },
            retainedAmount: function () {
                return this.retention ? ( this.cost / 100 * 15 ) : 0;
            },
            taxesAmount: function () {
                return this.cost / 100 * 21;
            },
            total: function () {
                return (this.cost + this.taxesAmount - this.retainedAmount).toFixed(2).replace('.', ',') + '€'
            },
            totalCost: function () {
                let totalCost = this.cost;


                // Restar IRPF si es empresa
                totalCost -= this.retainedAmount;

                // Sumar IVA
                totalCost += this.taxesAmount;

                // Sumar costes con impuestos ya pagados
                if (this.untaxedCosts) {
                    totalCost += this.untaxedCosts
                }

                return totalCost;
            },
            totalCostInEuros: function () {
                return this.totalCost.toFixed(2).replace(".", ",") + '€';
            }
        },

        mounted: function () {
            this.json = this.toJSON( false );

            bus.$emit( 'attachJsonToContactDialog', this.json );
        },

        updated: function () {
            this.json = this.toJSON( false );

            bus.$emit( 'attachJsonToContactDialog', this.json );
        },

        methods: {
            toJSON: function ( stringify = false ) {
                let budgetary = {
                    "budget": {
                        "steps": this.$parent.getJSON(),
                        "honoraries": this.honoraries,
                        "subtotal": this.cost,
                        "taxes": this.taxesAmount,
                        "retained": this.retainedAmount,
                        "untaxed": this.untaxedCosts,
                        "apostilles": this.apostilles,
                        "total": this.totalCost,
                        "service": this.service,
                        "delivery": this.deliveryCost
                    }
                };
                // ga('send', 'event', 'tariff-' + this.service, 'summary')
                return stringify ? JSON.stringify( budgetary ) : budgetary;
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/budgetary/BudgetSummary.vue